module.exports = __webpack_public_path__ + "img/closed-black-eye.b6eb1931.svg";